import axios from 'axios'
import { mockSearchSchools, mockSubmitErrorReport } from './mock/errorReportMock'

// 로그인 오류 신고 API mock은 로컬 개발용. VUE_APP_ERROR_REPORT_MOCK=true 일 때만 사용
const useErrorReportMock = process.env.VUE_APP_ERROR_REPORT_MOCK === 'true'

const userlogin = async (data) => {
  return await axios
    .post(`${process.env.VUE_APP_CONNECT}/users/login`, data, {
      credentials: true
    })
    .catch((err) => {
      return err.response
    })
}

const userinfo = async (token) => {
  return await axios.get(`${process.env.VUE_APP_CONNECT}/users`, {
    headers: {
      Authorization: token
    }
  })
}

const userfirstlogin = async (token) => {
  return await axios.get(`${process.env.VUE_APP_CONNECT}/users/first-login`, {
    headers: {
      Authorization: token
    }
  })
}

const userwearing = async (token) => {
  return await axios.get(`${process.env.VUE_APP_CONNECT}/games/wearing`, {
    headers: {
      Authorization: token
    }
  })
}

const userpasswordchange = async (token, data) => {
  return await axios.post(
    `${process.env.VUE_APP_CONNECT}/users/password/webgl`,
    data,
    {
      headers: {
        Authorization: token
      }
    }
  )
}

const usernicknamecheck = async (token, data) => {
  return await axios.post(
    `${process.env.VUE_APP_CONNECT}/users/nickname/check`,
    data,
    {
      headers: {
        Authorization: token
      }
    }
  )
}

const usernicknamechange = async (token, data) => {
  return await axios.put(
    `${process.env.VUE_APP_CONNECT}/users/nickname`,
    data,
    {
      headers: {
        Authorization: token
      }
    }
  )
}

const setuserfirstlogin = async (token) => {
  return await axios.get(`${process.env.VUE_APP_CONNECT}/users/firstloginset`, {
    headers: {
      Authorization: token
    }
  })
}

// 비로그인 학교 검색: [{ id, name: '서울 OO초등학교', schoolName, location }]
const searchSchools = async (keyword) => {
  if (useErrorReportMock) return mockSearchSchools(keyword)
  const res = await axios.get(`${process.env.VUE_APP_CONNECT}/schools/search`, {
    params: { keyword }
  })
  return res.data.data.schools
}

// 비로그인 오류 신고. 서버가 거절하면 사유(reason)를 담아 throw
const submitLoginErrorReport = async (payload) => {
  const result = useErrorReportMock
    ? await mockSubmitErrorReport(payload)
    : (await axios.post(`${process.env.VUE_APP_CONNECT}/mail/login-error`, payload))
        .data.data
  if (!result.success) {
    throw Object.assign(new Error('login error report rejected'), {
      reason: result.reason
    })
  }
  return result
}

export {
  userlogin,
  userinfo,
  userfirstlogin,
  userwearing,
  userpasswordchange,
  usernicknamecheck,
  usernicknamechange,
  setuserfirstlogin,
  searchSchools,
  submitLoginErrorReport
}
